module.exports = "/img/banner.302cd8ca.png";